import React, { useCallback, useRef, useState } from "react";
import { Toast } from "./Toast";
const ToastProvider = ({ render }) => {
  const displayTimeout = useRef();
  const [toast, setToast] = useState(null);
  const showToast = useCallback((options) => {
    if (displayTimeout.current)
      clearTimeout(displayTimeout.current);
    setToast(options);
  }, []);
  const hideToast = useCallback(() => {
    setToast((v) => ({ ...v, animationClass: "on-leave" }));
    displayTimeout.current = setTimeout(() => setToast(null), 500);
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, toast && /* @__PURE__ */ React.createElement(Toast, {
    ...toast,
    closeCallback: hideToast
  }), render({ showToast }));
};
export default ToastProvider;
